import React from 'react';

export var MagnifierPlusIcon = function MagnifierPlusIcon(props) {
  return React.createElement(
    "svg",
    { viewBox: "0 0 16 16", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement(
      "g",
      { fill: props.fillColor, fillRule: "evenodd" },
      React.createElement(
        "g",
        { transform: "translate(-1270.000000, -373.000000)" },
        React.createElement(
          "g",
          { transform: "translate(1069.000000, 365.000000)" },
          React.createElement(
            "g",
            { transform: "translate(198.890625, 5.430664)" },
            React.createElement("path", { d: "M13.5625,12.25 L12.87125,12.25 L12.62625,12.01375 C13.48375,11.01625 14,9.72125 14,8.3125 C14,5.17125 11.45375,2.625 8.3125,2.625 C5.17125,2.625 2.625,5.17125 2.625,8.3125 C2.625,11.45375 5.17125,14 8.3125,14 C9.72125,14 11.01625,13.48375 12.01375,12.62625 L12.25,12.87125 L12.25,13.5625 L16.625,17.92875 L17.92875,16.625 L13.5625,12.25 Z M8.3125,12.25 C6.13375,12.25 4.375,10.49125 4.375,8.3125 C4.375,6.13375 6.13375,4.375 8.3125,4.375 C10.49125,4.375 12.25,6.13375 12.25,8.3125 C12.25,10.49125 10.49125,12.25 8.3125,12.25 Z" }),
            React.createElement("polygon", { points: "10.5 8.75 8.75 8.75 8.75 10.5 7.875 10.5 7.875 8.75 6.125 8.75 6.125 7.875 7.875 7.875 7.875 6.125 8.75 6.125 8.75 7.875 10.5 7.875" })
          )
        )
      )
    )
  );
};